import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaPlus, FaSearch, FaEye, FaEdit, FaTrash, FaSpinner } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import { Modal} from 'antd';

const { confirm } = Modal;
const ListFAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDeleting, setIsDeleting] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetchFAQs();
  }, []);

const fetchFAQs = async () => {
  try {
    setLoading(true);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/faq`);
    if (!response.ok) {
      throw new Error('Failed to fetch FAQs');
    }

    const json = await response.json(); // 👈 parse the JSON

    if (json.success) {
      setFaqs(json.data); // 👈 this is your FAQ array
      toast.success(json.message); // 👈 show success toast
    } else {
      throw new Error(json.message || 'Something went wrong');
    }

  } catch (error) {
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};


  const handleDelete = async (id) => {
    confirm({
      title: 'Delete FAQ',
      content: 'Are you sure you want to permanently delete this FAQ? This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      centered: true,
      maskClosable: true,
      onOk: async () =>  {
      try {
        setIsDeleting(id);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/faq/${id}`, {
          method: 'DELETE',
        });
        
        if (!response.ok) {
          throw new Error('Failed to delete FAQ');
        }
        
        setFaqs(faqs.filter(faq => faq.id !== id));
        toast.success('FAQ deleted successfully');
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsDeleting(null);
      }
    }

    });
  };
const filteredFAQs = Array.isArray(faqs)
  ? faqs.filter(faq => {
      const matchesSearch =
        faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesSearch;
    })
  : [];


  const handleView = (faq) => {
    // Implement view functionality or open modal
    console.log('Viewing FAQ:', faq);
  };

  const handleEdit = (faq) => {
    navigate(`/admin/edit_faq/${faq.id}`);
  };

  const handleAdd = () => {
    navigate('/admin/create_faq');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {/* Header Section */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-800">FAQ Management</h2>
            <button
              onClick={handleAdd}
              className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
            >
              <FaPlus className="mr-2" />
              Add New FAQ
            </button>
          </div>

          {/* Search and Filter Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">
                Search
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search FAQs..."
                  className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
                <FaSearch className="absolute right-3 top-3 text-gray-400" />
              </div>
            </div>
            
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="p-8 flex justify-center">
            <FaSpinner className="animate-spin text-4xl text-blue-500" />
          </div>
        )}

        {/* Empty State */}
        {!loading && filteredFAQs.length === 0 && (
          <div className="p-8 text-center">
            <div className="text-gray-500 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-1">No FAQs found</h3>
            <p className="text-gray-500">Create one to get started!</p>
            <button
              onClick={handleAdd}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Create FAQ
            </button>
          </div>
        )}

        {/* FAQ Table */}
        {!loading && filteredFAQs.length > 0 && (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Question
                  </th>
                 
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Last Updated
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredFAQs.map((faq) => (
                  <tr key={faq.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">{faq.question}</div>
                      <div className="text-xs text-gray-500 mt-1 line-clamp-2"  dangerouslySetInnerHTML={{ __html: faq.answer }} 
>
                        {/* {faq.answer.substring(0, 100)}{faq.answer.length > 100 ? '...' : ''} */}
                      </div>
                    </td>
                   
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">
                        {new Date(faq.updated_at).toLocaleDateString()}
                      </div>
                      <div className="text-xs text-gray-400">
                        {new Date(faq.updated_at).toLocaleTimeString()}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
                      <button
                        onClick={() => handleView(faq)}
                        className="text-blue-600 hover:text-blue-900 p-2 rounded-full hover:bg-blue-50"
                        title="View"
                      >
                        <FaEye />
                      </button>
                      <button
                        onClick={() => handleEdit(faq)}
                        className="text-amber-600 hover:text-amber-900 p-2 rounded-full hover:bg-amber-50"
                        title="Edit"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => handleDelete(faq.id)}
                        disabled={isDeleting === faq.id}
                        className="text-red-600 hover:text-red-900 p-2 rounded-full hover:bg-red-50 disabled:opacity-50"
                        title="Delete"
                      >
                        {isDeleting === faq.id ? <FaSpinner className="animate-spin" /> : <FaTrash />}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListFAQ;